import {
  putFilteredZoom8HexagonsEv,
  putZoom8HexagonsEv,
} from '../models/zoom8Model/index.js';
import {
  putFilteredZoom9HexagonsEv,
  putZoom9HexagonsEv,
} from '../models/zoom9Model/index.js';
import {
  putFilteredZoom10HexagonsEv,
  putRawHex1Ev,
  putZoom10HexagonsEv,
  putRawHex2Ev,
  putRawHex3Ev,
  putRawHex4Ev,
  putRawHex5Ev,
  putRawHex6Ev,
  putRawHex7Ev,
  putRawHex8Ev,
  putRawHex9Ev,
} from '../models/zoom10Model/index.js';
import { hideLoaderEv, showLoaderEv } from '../models/webSocketModel/index.js';
import {
  putChartDataEv,
  putCityIndexEv,
  putFilteredChartDataEv,
  putFilteredIndexCardsDataEv,
  putIndexCardsDataEv,
} from '../models/indexCardsModel/index.js';
import { setUserInfoEv } from '../models/authModel/index.js';
import { cookies } from '../api/axiosinstance.js';
import { putSearchOptionsEv } from '../models/mapModel/index.js';
import { putIsochroneDataEv } from '../models/isochroneModel/index.js';
import { putBlockedBucketsEv } from '../models/gradientModel/index.js';
import { getDataPresetsEv } from '../models/dataPresetsModel/index.js';
import { putRawDataEv } from '../models/absoluteModel/index.js';

export function wsOnMessageHandler(message) {
  message = JSON.parse(message.data);
  console.log('WEBSOCKET:: wsOnMessageHandler: message', message);

  switch (message.action) {
    case 'users/login': {
      if (message.response.includes('expired token')) {
        cookies.remove('access_token', { path: '/' });
        // window.location.replace('/login');
      }
      break;
    }
    case 'rcp/get_polygons':
      switch (message.part) {
        case 'zoom_8':
          // putZoom8HexagonsEv(message.response.polygons);
          // putBlockedBucketsEv({
          //   zoom: 'zoom_8',
          //   value: message.response.gradient,
          // });
          break;
        case 'zoom_9':
          // putZoom9HexagonsEv(message.response.polygons);
          // putBlockedBucketsEv({
          //   zoom: 'zoom_9',
          //   value: message.response.gradient,
          // });
          break;
        case 'zoom_10':
          window.download_end = performance.now();
          window.mutate_start = performance.now();
          putZoom10HexagonsEv(message.response.polygons);
          putBlockedBucketsEv({
            zoom: 'zoom_10',
            value: message.response.gradient,
          });
          getDataPresetsEv();
          break;
        case 'city_total':
          putIndexCardsDataEv(message.response);
          putChartDataEv(message.response);
          putCityIndexEv(message.response.index);
          break;
        case 'raw':
          putRawDataEv(message.response);
          break;
        case 'raw_hex_1':
          putRawHex1Ev(message.response);
          break;
        case 'raw_hex_2':
          putRawHex2Ev(message.response);
          break;
        case 'raw_hex_3':
          putRawHex3Ev(message.response);
          break;
        case 'raw_hex_4':
          putRawHex4Ev(message.response);
          break;
        case 'raw_hex_5':
          putRawHex5Ev(message.response);
          break;
        case 'raw_hex_6':
          putRawHex6Ev(message.response);
          break;
        case 'raw_hex_7':
          putRawHex7Ev(message.response);
          break;
        case 'raw_hex_8':
          putRawHex8Ev(message.response);
          break;
        case 'raw_hex_9':
          putRawHex9Ev(message.response);
          hideLoaderEv();
          break;
        default:
          console.log('Unknown part: ', message);
          break;
      }
      break;
    case 'rcp/get_polygons_filtered':
      switch (message.part) {
        case 'zoom_8':
          putFilteredZoom8HexagonsEv(message.response.polygons);
          putBlockedBucketsEv({
            zoom: 'zoom_8',
            value: message.response.gradient,
          });
          break;
        case 'zoom_9':
          putFilteredZoom9HexagonsEv(message.response.polygons);
          putBlockedBucketsEv({
            zoom: 'zoom_9',
            value: message.response.gradient,
          });
          break;
        case 'zoom_10':
          putFilteredZoom10HexagonsEv(message.response.polygons);
          putBlockedBucketsEv({
            zoom: 'zoom_10',
            value: message.response.gradient,
          });
          hideLoaderEv();
          break;
        case 'city_total':
          putFilteredIndexCardsDataEv(message.response);
          putFilteredChartDataEv(message.response);
          break;
        default:
          console.log('Unknown part: ', message);
          break;
      }
      break;
    case 'users/info':
      if (message.response === 'Anonymous user')
        // window.location.replace('/login');
        setUserInfoEv(message.response);
      break;
    case 'map/get_point':
      putSearchOptionsEv(message.response);
      break;
    case 'map/get_isochrone':
      const id = `isochrone_lat_${message.payload.lat}_lon_${message.payload.lon}`;
      putIsochroneDataEv({ response: message.response, id });
      break;
    default:
      break;
  }
}

export function wsGetAlmatyPolygons() {
  showLoaderEv();
  window.ws.send(
    JSON.stringify({
      id: 'geo',
      action: 'rcp/get_polygons',
      partial: true,
    })
  );
}

export function wsSendAddFavorites(indexes) {
  window.ws.send(
    JSON.stringify({
      id: 'geo',
      action: 'user/favorite/add',
      payload: {
        api: 'rcp',
        index_ids: indexes,
      },
    })
  );
}
export function wsSendRemoveFavorites(indexes) {
  window.ws.send(
    JSON.stringify({
      id: 'geo',
      action: 'user/favorite/remove',
      payload: {
        api: 'rcp',
        index_ids: indexes,
      },
    })
  );
}

export function wsSendDarkTheme(dark_theme) {
  window.ws.send(
    JSON.stringify({
      id: 'geo',
      action: 'user/set_dark_theme',
      payload: {
        enable: dark_theme,
      },
    })
  );
}

export function wsGetSearchOptions(place) {
  window.ws.send(
    JSON.stringify({
      id: 'geo',
      action: 'map/get_point',
      payload: {
        address: place,
      },
      partial: false,
    })
  );
}

export function wsGetIsochrone(payload) {
  window.ws.send(
    JSON.stringify({
      action: 'map/get_isochrone',
      payload: {
        lat: payload.coordinates ? payload.coordinates[1] : null,
        lon: payload.coordinates ? payload.coordinates[0] : null,
        time: payload.time ? payload.time : 5,
        traffic: payload.traffic
          ? payload.type === 'walk'
            ? false
            : payload.traffic
          : false,
        type: payload.type ? payload.type : 'walk',
      },
    })
  );
}

export function wsGetFilteredPolygons(payload) {
  window.ws.send(
    JSON.stringify({
      action: 'rcp/get_polygons_filtered',
      payload: {
        region_ids: payload.region_ids ? payload.region_ids : [],
        index_ids: payload.index_ids ? payload.index_ids : [],
      },
      partial: true,
    })
  );
}
